export const getCenteredSubArray = <T>(arr: T[], indexToCenter: number, length: number): T[] => Array.from({ length }, (_, i) => arr[(indexToCenter + i + arr.length - 2) % arr.length]);

// Example usage
// const arr = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49];
// const indexToCenter = 0;
// const subArr = getCenteredSubArray(arr, indexToCenter, 5);
// console.log(subArr); // [48, 49, 0, 1, 2]
